import {
  ITabelFieldViewProps,
  ITableFields,
  TABLE_FIELD_ALIGN,
  TABLE_FIELD_TYPE,
} from "../../core-component/ui/ICTable";
import { TReactSetState, TUseTranslationTfn } from "../../data/AppType";
import { GET_ALL_SUBSCRIPTION_PACKAGE } from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  formatDuration,
  handleError,
  sweetAlertError,
} from "../../utils/AppFunctions";
export interface IFeatures {
  feature_title: string;
  help_text: string;
  annotation: string;
}

export interface ISubscriptionPackage {
  id: string;
  name: string;
  description: string;
  base_price: number;
  validity: number;
  sgst: number;
  cgst: number;
  igst: number;
  total: number;
  features: [IFeatures];
}

export function getSubscriptionPackageFields<T>(
  actionComponent: (item: T) => JSX.Element,
  t: TUseTranslationTfn
): ITableFields<T>[] {
  return [
    {
      name: t("name"),
      key: "name",
      sort: false,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-1",
    },
    {
      name: t("description"),
      key: "description",
      sort: false,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-4",
      limit: 50,
    },
    {
      name: t("validity"),
      key: "validity",
      sort: false,
      type: TABLE_FIELD_TYPE.format,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-2",
      format: ({ field, data }: ITabelFieldViewProps<T>) =>
        data["validity"] ? formatDuration(data["validity"]) : "-",
    },
    {
      name: t("base_price"),
      key: "base_price",
      sort: false,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-2",
    },
    {
      name: t("action"),
      key: "action",
      sort: false,
      type: TABLE_FIELD_TYPE.custom,
      align: TABLE_FIELD_ALIGN.center,

      flex: "col-span-1",
      component: actionComponent,
    },
  ];
}

export const getAllSubscriptionPackage = async (
  setSubscriptionPackageList: TReactSetState<ISubscriptionPackage[]>
) => {
  try {
    const subscriptionPackageField = await GET_ALL_SUBSCRIPTION_PACKAGE();
    if (
      subscriptionPackageField &&
      subscriptionPackageField.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      setSubscriptionPackageList(subscriptionPackageField.data);
    } else {
      setSubscriptionPackageList([]);
      sweetAlertError({
        message:
          subscriptionPackageField.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (error: any) {
    handleError(error, "getAllSubscriptionPackage");
  }
};
